






import { Component, Vue } from "vue-property-decorator";
import BaseView from "@/components/Base/Elements/BaseView.vue";
import Admin from "@/components/Admin/Admin.vue";

@Component({
  extends: BaseView,
  components: {
    Admin
  }
})
export default class AdminView extends Vue {}
